export default "<main id=\"main\" aria-role=\"main\" class=\"dashboard-page\">\n  <div ui-view class=\"container-fluid dashboard-page\"></div>\n</main>\n"